import { useSyncState, deriveStatus } from "../lib/sync";
import { Cloud, CloudOff, RefreshCw, CheckCircle2, AlertTriangle } from "lucide-react";

const TONES = {
  synced: { cls: "bg-primary/10 text-primary border-primary/20", Icon: CheckCircle2 },
  syncing: { cls: "bg-amber-50 text-amber-700 border-amber-200", Icon: RefreshCw },
  local: { cls: "bg-amber-50 text-amber-700 border-amber-200", Icon: Cloud },
  offline: { cls: "bg-slate-100 text-slate-600 border-slate-200", Icon: CloudOff },
  error: { cls: "bg-red-50 text-red-700 border-red-200", Icon: AlertTriangle },
};

export default function SyncBadge() {
  const s = useSyncState();
  const { label, tone } = deriveStatus(s);
  const { cls, Icon } = TONES[tone] || TONES.synced;
  return (
    <div
      data-testid="sync-badge"
      data-sync-tone={tone}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold ${cls}`}
    >
      <Icon className={`h-3.5 w-3.5 ${tone === "syncing" ? "animate-spin" : ""}`} />
      <span>{label}</span>
      {s.pending > 0 && tone !== "synced" && (
        <span className="ml-0.5 rounded-full bg-white/60 px-1.5">{s.pending}</span>
      )}
    </div>
  );
}
